import { render, staticRenderFns } from "./VideoPost.vue?vue&type=template&id=8a981454&scoped=true&"
import script from "./VideoPost.vue?vue&type=script&lang=js&"
export * from "./VideoPost.vue?vue&type=script&lang=js&"
import style0 from "./VideoPost.vue?vue&type=style&index=0&id=8a981454&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a981454",
  null
  
)

export default component.exports